<h2 mat-dialog-title>
  {{ "components.opening-times-overview.title" | translate }}
</h2>
<mat-dialog-content class="content">
  @for (day of weekDays; track day; let i = $index) {
    <div>
      <div class="list-item" [class.has-border]="i > 0">
        <span class="week-day">{{ "enums.weekdays." + day | translate }}</span>
        <div class="opened-container">
          <span class="opened">
            @if (getCrossedOpeningTimes(day); as crossed) {
              <div class="crossed">
                {{ crossed | translate }}
              </div>
            }
            {{ getOpeningTimes(day) | translate }}
          </span>
          <button
            mat-icon-button
            class="icon-button"
            (click)="editOpeningTimes(day)"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>
    </div>
  }
  <button mat-button (click)="editAllOpeningTimes()">
    {{
      "components.opening-times-overview.button-edit-multiple-days" | translate
    }}
  </button>
  <button
    mat-button
    mat-dialog-close
    (click)="currentOpeningTimesService.setFinalCurrentOpeningTimes()"
  >
    {{ "components.opening-times-overview.button-save-changes" | translate }}
  </button>
</mat-dialog-content>
